import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initMercadoPago } from "@mercadopago/sdk-react";
import "@/index.css";
import App from "@/App";

if (process.env.REACT_APP_MP_PUBLIC_KEY) {
  initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY, { locale: "pt-BR" });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
